import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Api from "services/api"


export const initialState = {
  patients: [],
  error: null,
  loader: false,
  featured: {},
  total: 0,
  is_more: false,
  last_page: 1,
  current_page: 1,
}

export const patientSlice = createSlice({
  name: 'patients',
  initialState: initialState,
  reducers: {
    setPatient: (state, { payload }) => {
      state.patients = payload?.data ?? payload;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
    },
    setPatients: (state, { payload }) => {
      state.patients = payload?.data;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
    },
    setMorePatients: (state, { payload }) => {
      state.data = state.data.concat(payload.data);
      state.total = payload.total;
      state.is_more = payload.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
    },
    removePatient: (state, { payload }) => {
      state.error = payload
    },
    clearAllPatient: (state, { payload }) => {
      state.loader = payload
    },
    setError: (state, { payload }) => {
      state.error = payload
    },
    setLoader: (state, { payload }) => {
      state.loader = payload
    },
  }
})

// const reducer = (state = initialState, action) => {
//   switch (action.type) {
//     case types.INIT_APP:
//     case types.GO_TO_DETAILS:
//       return { ...state, ...action.payload }
//     default:
//       return state
//   }
// }

export const filterPatient = (data, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.filterPatient(data)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setPatient(json.data))
      callback(true, json?.data?.data)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data?.errors)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const addPatient = (data, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.addPatient(data)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setPatient(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const updatePatient = (data, itemId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.updatePatient(data, itemId)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setPatient(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const removePatient = (itemId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.removePatient(itemId)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setPatient(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const fetchPatients = (page, params, disableLoader) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true))
  try {

    const result = await Api.fetchPatients(page, params)
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        dispatch(setPatients(result.data.data));
      } else {
        dispatch(setPatients(result.data.data));
      }
    }
    else if (result?.status == 422) {
      dispatch(setError(result.data))
    }
  } catch (error) {
    console.log("error", error)

  }
  !disableLoader && dispatch(setLoader(false))
}


export const changeStatus = (id, data) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.statusChange(id, data, "patient")
    if (json.status >= 200 && json.status < 300) {
      // console.log(json)
      // dispatch(setHospital(json.data))
      // callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      // callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const removeMultiplePatients = (ids, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.removeMultiplePatients(ids)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setHospital(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const { setPatient, setPatients, clearAllPatient, setLoader, setError, setMorePatients } = patientSlice.actions


export default patientSlice.reducer
export const patientSelector = state => state.patients


